import { FileAttachment02, Trash03 } from "untitledui-js-base";
import { IconButtonSize, IconButton } from "shared/components";
import { Select } from "shared/components";
import { FC } from "react";
import { DocTypeOptions } from "../../constants";

interface Props {
  file: File;
  isTypeError: boolean;
  onDelete: () => void;
  onSelectType: (type: string) => void;
}

export const FilePreview: FC<Props> = ({
  file,
  isTypeError,
  onDelete,
  onSelectType
}) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-3">
      <div className="p-[10px] bg-primary-20 rounded-lg">
        <FileAttachment02 className="stroke-primary-500" size="20" />
      </div>
      <div className="w-full">
        <p className="truncate max-w-[400px] text-sm font-bold text-content-1000">
          {file.name}
        </p>
        <p className="text-xs text-content-200">Uploaded</p>
      </div>
    </div>
    <div className="flex items-center gap-2">
      <Select
        error={isTypeError}
        className="w-80 !m-0"
        id={`document-${file.name}`}
        placeholder="Select document type"
        options={DocTypeOptions}
        onChange={(e) => onSelectType(e.target.value)}
      />
      <IconButton
        className="stroke-danger-500"
        Icon={Trash03}
        size={IconButtonSize.BASE}
        onClick={onDelete}
      />
    </div>
  </div>
);
